import React, { useRef, useState } from 'react';

import { Link } from 'react-router-dom';

import { CollectionPeek } from '@pkg/components/Collections/CollectionPeek';
import { useBreakpoints } from '@pkg/hooks';

import { CollectionChainType, SupportedTokens } from '@app/client';

interface Props {
    slug?: string | null;
    disablePeek?: boolean;
    chain?: CollectionChainType;
    children: React.ReactNode;
    collection_name?: string;
    collection_image?: string;
    collection_count?: string;
}

export const CollectionLink = ({
    slug,
    children,
    disablePeek: _disablePeek,
    chain = CollectionChainType.Ethereum,
    collection_name,
    collection_image,
    collection_count,
}: Props) => {
    const [isHovered, setIsHovered] = useState(false);
    const ref = useRef<HTMLAnchorElement>(null);
    const { isMobile } = useBreakpoints();

    if (!children) return null;
    if (!slug || slug === '') return <>{children}</>;

    // TODO Remove once we support multichain peek
    const disablePeek = _disablePeek; // || chain !== CollectionChainType.Ethereum;

    const handleMouseOver = () => {
        setIsHovered(true);
    };
    const handleMouseOut = () => {
        setIsHovered(false);
    };

    const linkTo = chain ? `/collection/${SupportedTokens[chain]}/${slug}` : undefined;

    return (
        <>
            {linkTo ? (
                <Link
                    ref={ref}
                    onMouseEnter={handleMouseOver}
                    onMouseLeave={handleMouseOut}
                    onClick={(e) => e.stopPropagation()}
                    to={linkTo}
                >
                    {children}
                </Link>
            ) : (
                children
            )}
            {!isMobile && !disablePeek ? (
                <CollectionPeek
                    slug={slug}
                    hovered={isHovered}
                    linkElement={ref}
                    collection_name={collection_name}
                    collection_image={collection_image}
                    collection_count={collection_count}
                />
            ) : null}
        </>
    );
};
